/**
 * @file store/pluginStore.tsx
 * @description 插件中心相关的轻量状态（Zustand）：用于缓存已选插件/筛选条件等。
 */
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export const usePluginStore = create(
  persist(
    set => ({
      pluginDetail: {},
      /**
       * 写入/覆盖插件详情缓存
       * @param detail 插件详情对象
       */
      setPluginDetail: detail => {
        set(state => ({
          pluginDetail: detail
        }))
      }
    }),
    {
      name: 'plugin-storage', // name of item in the storage (must be unique)
      getStorage: () => localStorage // (optional) by default the 'localStorage' is used
    }
  )
)
